/**
 * @module refreshClientConfiguration
 */

import store from '../store/store';
import { ClientConfigurationRequestState } from '../store/schema/clientConfiguration';
import loadClientConfiguration from '../actions/loadClientConfiguration';

/**
 * @function
 * To fetch the new set of client configuration from the Actionable Message service
 * @returns nothing
 */

const refreshClientConfiguration = (): void => {
    if (store.requestState === ClientConfigurationRequestState.InProgress) {
        return;
    }
    loadClientConfiguration();
};

export default refreshClientConfiguration;
